<template>
  <div class="fullscreen-bg" :style="bgStyle">
    <button class="back-button" @click="goBack">
    </button>
    <div class="mapContiner">
      <echarts/>
    </div>
  </div>
</template>

<script>
import echarts from "@/components/echartsMenu/screenEcharts.vue";
import { mapState } from 'vuex';
export default {
  components:{
    echarts
  },
  computed: {
    ...mapState('echartsMap', ['screenMaplevel']), // 从vuex获取地图层级
    bgStyle() {
      // 根据层级返回不同的背景图样式
      const bgImages = [
        require('@/assets/recycling/index/large-screen-bg.png'), // 省级背景
        require('@/assets/recycling/index/large-screen-bg1.png'),        // 市级背景
        require('@/assets/recycling/index/large-screen-bg1.png')     // 区级背景
      ];
      
      return {
        backgroundImage: `url(${bgImages[this.screenMaplevel] || bgImages[0]})`,
        backgroundSize: '100% 100%',
        backgroundPosition: 'center center',
        backgroundRepeat: 'no-repeat'
      };
    }
  },
  methods: {
    goBack() {
      if (this.$router) {
        this.$router.go(-1);
      } else {
        window.history.back();
      }
    },
  },
  destroyed() {
    this.$store.commit('echartsMap/SET_MAP_LEVEL',0) // 修改vuex里面的层级
  },
}
</script>

<style lang="less" scoped>
.fullscreen-bg {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  transition: background-image 0.5s ease; /* 添加背景图切换动画 */
}

.back-button {
  position: absolute;
  top: 0px;
  left: 0;
  width: 180px;
  height: 100px;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s ease;
  z-index: 10;
  font-size: 14px; /* 为文字添加样式 */
  color: #333; /* 文字颜色 */
}

.mapContiner {
  width: 900px;
  height: 700px;
  position: fixed;
  left: 0;
  right: 0;
  top: 10%;
  bottom: 0;
  margin: auto;
}
</style>

